import React, { useEffect,useState } from "react";

const faqData = [
  {
    question: "What services does OmSai Credit Collection Services Pvt. Ltd. provide?",
    answer:
      'OmSai Credit Collection Services Pvt. Ltd. specializes in professional debt collection solutions, including recovery for NBFCs, banks, and financial institutions. We offer field collection, tele-calling, legal recovery, and consulting services to help clients minimize NPAs and improve their cash flow.',
  },
  {
    question: "Which sectors or businesses do you cater to?",
    answer:
      "We primarily serve NBFCs, banks, microfinance institutions, telecom companies, fintech platforms, and other organizations requiring end-to-end credit recovery and management solutions.",
  },
  {
    question: "How does OmSai ensure ethical and compliant recovery practices?",
    answer:
      "OmSai follows a strict code of conduct aligned with RBI and industry guidelines. Our recovery agents are trained in ethical collection techniques and customer interaction, ensuring transparency, respect, and compliance throughout the recovery process.",
  },
  {
    question: "Can OmSai handle collections across multiple locations?",
    answer:
      "Yes, we operate across multiple cities in Maharashtra and have a wide network of trained collection agents and field executives. Our scalable infrastructure enables us to serve clients both regionally and nationally.",
  },
  {
    question: "How can I partner with OmSai for collection services?",
    answer:
      "You can contact us via our website or email, and our business development team will get in touch with you. We’ll understand your requirements and propose a customized recovery strategy tailored to your needs.",
  },
];

const FaqAccordion = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleIndex = (index) => {
    setActiveIndex((prevIndex) => (prevIndex === index ? null : index));
  };

  const [isMobile, setIsMobile] = useState(false);
  
    useEffect(() => {
      const checkMobile = () => {
        setIsMobile(window.innerWidth <= 768);
      };
      checkMobile();
      window.addEventListener('resize', checkMobile);
      return () => window.removeEventListener('resize', checkMobile);
    }, []);

  return (
    <div style={{ background: "#f1e7e7", width: "100%", padding: "50px 0",marginBottom:"0px" }}>
      <div
        style={{
          maxWidth: "950px",
          margin: "0 auto",
          padding: "0 30px",
          fontFamily: "outfit, sans-serif",
          color: "#000",
          
        }}
      >
        <h2
          style={{
            fontSize: "35px",
            fontWeight: "700",
            color: "#000",
            textAlign: "center",
            marginBottom: "40px",
            fontWeight:"900"
          }}
        >
          Frequently Asked Questions.
        </h2>

        {faqData.map((item, index) => (
          <div
            key={index}
            style={{
              background: activeIndex === index ? "#f7c53f" : "#fff",
              marginBottom: "12px",
              borderRadius: "8px",
              overflow: "hidden",
              transition: "all 0.3s ease",
              boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
              border: "1px solid #ddd",
            }}
          >
            <div
              onClick={() => toggleIndex(index)}
              style={{
                cursor: "pointer",
                padding: "16px 20px",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                fontWeight: "600",
                fontSize: "18px",
              }}
            >
              <span>{item.question}</span>
              <span
                style={{
                  fontSize: "18px",
                  fontWeight: "700",
                  color: "#000",
                  marginLeft: "10px",
                }}
              >
                {activeIndex === index ? "−" : "+"}
              </span>
            </div>

            {activeIndex === index && (
              <div
                style={{
                  background: "#fff",
                  padding: "18px 20px",
                  fontSize: "15px",
                  lineHeight: "1.5",
                  borderTop: "1px solid #ccc",
                }}
              >
                {item.answer}
              </div>
            )}
          </div>
        ))}
      </div>

    </div>
  );
};

export default FaqAccordion;
